import { Component, OnInit, OnDestroy } from '@angular/core';
import {AssessmentGroup } from '../../shared/models/assessment-group';
import {Assessment } from '../../shared/models/assessment';
import {ShoppingService} from "../../shared/services/shopping.service";
import {Item} from '../models/item';
import {ActivatedRoute, Router} from '@angular/router';
import { AlertService } from 'app/shared/services/alert.service';
import { AuthService } from '../../login/services/auth.service';
import { Role } from '../../shared/models/role';
import { ISubscription } from 'rxjs/Subscription';
import { BillingService } from 'app/shared/services/billing.service';
import { BillingCard } from 'app/shared/models/billing-card';
import { BillingDetails } from 'app/shared/models/billing-details';

@Component({
  selector: 'checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.css']
})
export class CheckoutComponent implements OnInit, OnDestroy {

  private _inCheckoutProcess:boolean;
  private _billingCard:BillingCard;
  private _useExistingCard:boolean;
  private _billingDetails:BillingDetails;
  private _loadingPaymentInformation:boolean;
  private _isAdmin:boolean;
  private _userSubscription:ISubscription;

  constructor(
    private shopping:ShoppingService
    ,private router:Router
    ,private alertService: AlertService
    ,private route:ActivatedRoute
    ,private billingService:BillingService
    ,private authService:AuthService
  ) { 
    this._inCheckoutProcess = false;
    this.useSavedCard = false;
    this._loadingPaymentInformation = false;
    this._isAdmin = false;
    this._userSubscription = this.authService.getLoginState().subscribe(loginState => {
      if (loginState.user) {
        this._isAdmin = loginState.user.role <= Role.Admin;
      }
      else {
        this._isAdmin = false;
      }
    });
  }

  ngOnDestroy() {
    this._userSubscription.unsubscribe();
  }
  ngOnInit() {
    this._loadingPaymentInformation = true;
    this.billingService.getBillingDetails().then((details) => {
      this._loadingPaymentInformation = false;
      this._billingDetails = details; // use the first one.
      if (this._billingDetails.hasCards()) {
        this._billingCard = this._billingDetails.cards[0];
        this.setCheckoutSavedCard();
      }
    })
    .catch((error) => {
      console.error(error);
      this._loadingPaymentInformation = false;
      this.alertService.error("There was an error loading your payment information from the server.  Use a new card or contact support");
    });
  }

  get isSingleOrder() {
    return this.shopping.isSingleCheckoutOrder();
  }

  get loadingPaymentInformation() {
    return this._loadingPaymentInformation;
  }

  get inCheckoutProcess() {
    return this._inCheckoutProcess;
  }


  get hasItems() {
    return this.shopping.hasItems;
  }

  get orderTotal() {
    return this.shopping.cartTotal;
  }

  get items() {
    return this.shopping.cartItems;
  }

  removeItem(item:Item) {
    this.shopping.removeItemFromCart(item).then(() => {
      let message = item.name + " removed from your cart.";
      this.alertService.success(message);
    });
  }

  shouldShowPaymentInformation() {
    // we only show if this is a paid item, and if we have a saved billing card.
    if (this.shopping.cartTotal > 0) {
      // if we are an admin and haven't setup a billing profile we want to show the payment details.
      if (this.canUpdateBillingProfile()) {
        return true;
      }
      if (this._billingDetails.hasCards() != null) {
        return true;
      }
    }
    return false;
  }

  setCheckoutSavedCard() {
    this.useSavedCard = true;
  }

  setCheckoutNewCard() {
    this.useSavedCard = false;
  }

  get BillingCard() {
    return this._billingCard;
  }

  get useSavedCard() {
    return this._useExistingCard;
  }
  set useSavedCard(v:boolean) {
    this._useExistingCard = v;
  }

  canUpdateBillingProfile() {
    return this._isAdmin;
  }

  openCheckout() {
    this._inCheckoutProcess = true;
    this.shopping.checkout(this.useSavedCard).then(() => {
      this.router.navigate(["/admin", "shop", "checkout", "thankyou"]);
    })
    .catch((error) => {
      console.error(error);
      this.alertService.error("An error occurred in processing your checkout.  Check your card information and try again or contact customer support.");
      this._inCheckoutProcess = false;
    });
  }

  cancelSingleCheckoutOrder() {
    let returnUrl = this.shopping.getSingleItemCheckoutReturnUrl();
    this.shopping.endSingleItemCheckout();

    if (!returnUrl) {
      console.error("No return url found to return to for single item checkout");
      returnUrl = "/admin/clients/"
    }
    this.router.navigateByUrl(returnUrl);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/checkout/checkout.component.ts